import React from "react";
import exampleCSV from "files/Shelter-Animals-Count_Sample-Import.csv";
import Upload from "../../components/DataEntryUpload";

const DataEntryUpload = () => (
  <Upload exampleCSV={exampleCSV} action="data-entry" />
);

export default DataEntryUpload;
